import { useState } from 'react';
import { MIN_SWIPE_DISTANCE } from '../../../../constants/Constants';

interface useMobileSwipeProps {
  setTouchPosition: (position: number) => void;
  nextSlide: () => void;
  prevSlide: () => void;
}

export const useMobileSwipe = ({ setTouchPosition, nextSlide, prevSlide }: useMobileSwipeProps) => {
  // position of the touch start
  const [touchStart, setTouchStart] = useState(0);
  // position of the touch end
  const [touchEnd, setTouchEnd] = useState(0);
  // true if the user is swiping
  const [isSwiping, setIsSwiping] = useState(false);

  // function to handle touch start
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
    setIsSwiping(true);
  };

  // set the touch position and calculate the distance when the user is swiping
  const handleTouchMove = (e: React.TouchEvent) => {
    const currentPosition = e.targetTouches[0].clientX;

    setTouchEnd(e.targetTouches[0].clientX);
    setTouchPosition(currentPosition - touchStart);
  };

  // handle touch end
  const handleTouchEnd = () => {
    if (touchStart - touchEnd > MIN_SWIPE_DISTANCE) {
      // Swipe Left, show next
      nextSlide();
    }

    if (touchEnd - touchStart > MIN_SWIPE_DISTANCE) {
      // Swipe Right, show previous
      prevSlide();
    }
    setIsSwiping(false);
    setTouchPosition(0);
  };

  return {
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    isSwiping,
  };
};
